import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const ArdeerPage = () => (
  <CostcoLocationTemplate
    warehouseName="Ardeer"
    suburb="Ardeer"
    state="Victoria"
    stateShort="VIC"
    address="Western Ring Rd & Ballarat Rd, Ardeer VIC 3022"
    path="/costco/ardeer"
    description="Manage Your Loans is the proud Costco member loan partner for the Ardeer warehouse in Melbourne's west. We help Costco Executive Members across Ardeer, Deer Park, Sunshine and surrounding suburbs access competitive home loans, car loans and personal loans — with exclusive Costco Shop Card rewards on settlement."
    nearbySuburbs={[
      'Ardeer',
      'Deer Park',
      'Sunshine',
      'St Albans',
      'Cairnlea',
      'Caroline Springs',
      'Albanvale',
      'Kings Park',
      'Keilor Downs',
      'Delahey',
    ]}
    localContext={[
      {
        title: 'Western Melbourne Growth Corridor',
        description:
          'The western suburbs are one of Melbourne\'s fastest-growing corridors, with significant infrastructure investment driving property demand. First home buyers and upgraders in areas like Caroline Springs and Cairnlea are finding strong value compared to inner-city markets.',
      },
      {
        title: 'Affordable Entry Suburbs',
        description:
          'Suburbs such as Deer Park, St Albans and Ardeer continue to offer accessible entry points for buyers looking to get into the property market. Competitive lending options can make a real difference in these high-demand growth pockets.',
      },
      {
        title: 'Sunshine Transport Hub',
        description:
          'The Sunshine precinct is set for major transformation with the Metro Tunnel and Airport Rail Link, making nearby suburbs increasingly attractive for homeowners and investors seeking long-term capital growth.',
      },
    ]}
    faqs={[
      {
        q: 'How do I claim my Costco Shop Card reward after settling a loan?',
        a:
          'Once your loan settles through Manage Your Loans, we verify your Costco Executive Membership and arrange your Shop Card reward. The process is straightforward — just ensure your membership is active at the time of settlement. Terms and conditions apply.',
      },
      {
        q: 'Can I use the Costco member loan service if I live in Deer Park or Sunshine?',
        a:
          'Absolutely. Our Costco member loan partnership covers all suburbs near the Ardeer warehouse, including Deer Park, Sunshine, St Albans, Cairnlea, Caroline Springs, and surrounding areas. You don\'t need to live in Ardeer itself to access the program.',
      },
      {
        q: 'What types of loans qualify for the Costco Shop Card offer?',
        a:
          'Home loans, car loans, and personal loans settled through Manage Your Loans as a Costco Executive Member may qualify for Shop Card rewards. Each loan type has specific terms — contact us on 0468 007 056 for details.',
      },
      {
        q: 'Is there an advantage to using a broker near the Ardeer Costco warehouse?',
        a:
          'Working with a broker who understands western Melbourne\'s property market means you get tailored advice for suburbs like Ardeer, Caroline Springs and Kings Park. We know the local lending landscape and can match you with lenders who favour this growth corridor.',
      },
    ]}
    suburbData={{
      suburb: 'Ardeer',
      medianHouse: '$620,000',
      medianUnit: '$380,000',
      daysOnMarket: '32 days',
      rentalYield: '3.8%',
      population: '3,200',
      distanceToCostco: '1 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Deer Park', medianHouse: '$600,000', medianUnit: '$370,000', daysOnMarket: '30 days' },
      { suburb: 'Sunshine', medianHouse: '$720,000', medianUnit: '$420,000', daysOnMarket: '28 days' },
      { suburb: 'St Albans', medianHouse: '$620,000', medianUnit: '$380,000', daysOnMarket: '31 days' },
      { suburb: 'Cairnlea', medianHouse: '$750,000', medianUnit: '$450,000', daysOnMarket: '26 days' },
      { suburb: 'Caroline Springs', medianHouse: '$730,000', medianUnit: '$440,000', daysOnMarket: '25 days' },
      { suburb: 'Albanvale', medianHouse: '$590,000', medianUnit: '$360,000', daysOnMarket: '33 days' },
      { suburb: 'Kings Park', medianHouse: '$640,000', medianUnit: '$390,000', daysOnMarket: '29 days' },
      { suburb: 'Keilor Downs', medianHouse: '$700,000', medianUnit: '$420,000', daysOnMarket: '27 days' },
      { suburb: 'Delahey', medianHouse: '$650,000', medianUnit: '$400,000', daysOnMarket: '30 days' },
    ]}
  />
);

export default ArdeerPage;
